module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAaCAYAAABctMd+AAABL0lEQVRIS+2VMUrEQBiF33NgNwhaeALBZk8g2AmieIEpwqSzsxIv4AUED2AhhHRprRW02RsIWugFIhZCIK4+ibAaYkhCTCzEaed/3/zzDTNDDDg4IBt/BO77/sQYswdgC8CapCWSnXf3EbTWjjzPO5a0D8D0dQ601prxeHwOYLcv6JxD59wByZO+wTkvh9+QnBTgLwCShsVWAIyaGmIQBLOS52kURRt1wSAILgFstoGrVDQo/AnAtK4rSeskczW1I9dS7rwp03r+G1zSI8mr1oSvwh0Ai8VcVeeNzqsWds7dk1z9LfhblZYZyecOWpYBLMxzkh4GO1BJR0PBr5Mk2e4b/irpNMuywziO0xyedvBbjKSS7gBcGGPOwjC8/XwVfwiuv6H/8CoDnT/fNjrfAbE9bl6y/BjmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_name.png
// module id = oahz
// module chunks = 0